module.exports = __webpack_public_path__ + "img/bg_z.7d3e38f1.png";